import React, { useState } from "react"
import './sidebar.css'
import { Link, useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import ISO6391 from 'iso-639-1';
import LogoComponent from "../logo";

const Sidebar = ({ siteTitle, categories, currentCategory, currentPage, visible }) => {
    const { changeLanguage } = useI18next()
    const { language, languages } = useI18next();
    const [selectedLanguage, setSelectedLanguage] = useState(language);
    const { t } = useTranslation();

    const handleSelectedLanguageChange = (selectedLanguage) => {
        setSelectedLanguage(selectedLanguage);
        changeLanguage(selectedLanguage);
    };

    return (
        <nav id="sidebar" className={`sidebar ${visible ? "sidebar-shown" : "sidebar-hidden"}`}>
            <div className="sidebar-logo">
                <LogoComponent />
            </div>
            <div className="sidebar-section mt-5">
                <h6>{t('common.categories', { lng: language })}</h6>
                <ul className="list-unstyled components mb-5 mt-3">
                    {categories
                        .filter(category => !category.hidden)
                        .map((category) => (
                            <li key={category.id} className="mt-3">
                                <Link to={`/categories/${category.url}`}>
                                    <span className="me-2 category-emoji">{category.emoji}</span>
                                    <span className={`sidebar-option ${currentCategory?.mongodb_id === category.mongodb_id ? "sidebar-option-active" : ""}`}>{category.name[language] || category.name.en}</span>
                                </Link>
                            </li>
                        ))}
                </ul>
            </div>
            <div className="sidebar-section mt-5">
                <h6>{t('common.about', { lng: language })}</h6>
                <ul className="list-unstyled components mb-5 mt-3">
                    <li key='terms' className="mt-3">
                        <Link to={`/terms`}>
                            <span className={`sidebar-option ${currentPage === "terms" ? "sidebar-option-active" : ""}`}>{t('common.terms', { lng: language })}</span>
                        </Link>
                    </li>
                    <li key='privacy ' className="mt-3">
                        <Link to={`/privacy`}>
                            <span className={`sidebar-option ${currentPage === "privacy" ? "sidebar-option-active" : ""}`}>{t('common.privacy', { lng: language })}</span>
                        </Link>
                    </li>
                </ul>
            </div>
            <div className="sidebar-section mt-5">
                <h6>{t('common.language', { lng: language })}</h6>
                <select name="category" className="mb-4 language-menu border" aria-label={t('common.language', { lng: language })} value={selectedLanguage} onChange={event => handleSelectedLanguageChange(event.target.value)}>
                    {languages.map(lang => (
                        <option key={lang} value={lang} aria-label={ISO6391.getName(lang)}>
                            <span className="language-menu-item" aria-label={ISO6391.getName(lang)}>
                                {ISO6391.getName(lang)}
                            </span>
                        </option>
                    ))}
                </select>
            </div>
            <div className="footer mt-4">
                <p>&copy; {siteTitle}</p>
            </div>
        </nav>
    )
}

export default Sidebar